import React, { useState } from 'react';
import Navigation from '../components/Navigation/Navigation';
import { InDesignExportSettings } from '../components/settings/InDesignExportSettings';
import apiClient from '../utils/apiClient';

const InDesignPage: React.FC = () => {
  const [history, setHistory] = useState<Array<{ id: number; filename: string; created_at: string }>>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const loadHistory = async () => {
    setLoading(true); setError('');
    try { setHistory((await apiClient.get('/bulletins/indesign-settings/exports', { params: { churchId: 2 } })).data); }
    catch { setError('Could not load saved exports.'); }
    finally { setLoading(false); }
  };
  return <>
    <Navigation />
    <main className="container py-4">
      <h1>InDesign Bulletins</h1>
      <InDesignExportSettings />
      <details className="mt-4" onToggle={e => { if (e.currentTarget.open) loadHistory(); }}>
        <summary>Saved 8 am exports</summary>
        <p>Download an original export, including its prayer texts, even after a seasonal template changes.</p>
        <button type="button" disabled={loading} onClick={loadHistory}>{loading ? 'Loading…' : 'Refresh saved exports'}</button>
        {error && <p role="alert">{error}</p>}
        {!loading && history.length === 0 && <p>No saved exports yet.</p>}
        <ul>{history.map(item => <li key={item.id}>
          <button type="button" onClick={async () => {
            try {
              const { data } = await apiClient.get(`/bulletins/indesign-settings/exports/${item.id}`);
              const url = URL.createObjectURL(new Blob([JSON.stringify(data.payload, null, 2)], { type: 'application/json' }));
              const link = document.createElement('a'); link.href = url; link.download = data.filename;
              document.body.appendChild(link); link.click(); link.remove();
              setTimeout(() => URL.revokeObjectURL(url), 1000);
            } catch { setError('Could not download that saved export.'); }
          }}>{item.filename}</button> · {new Date(item.created_at).toLocaleString()}
        </li>)}</ul>
      </details>
    </main>
  </>;
};
export default InDesignPage;
